import React, { useEffect } from "react";
import logo from "../../../assets/logosss.png";
import { P } from "../../../components/Common/Typo/typo";
import SingleBar from "../../../components/charts/SingleBar";
import Thaihealth from "../../../assets/thaihealth.png";

interface TargetCardProps {
  occupancyInsightsData: {
    data: { insight_message: string }[];
  };
  todayCarbonFootprintData: {
    data: {
      carbon_total: number;
      staff_percentage: number;
      visitor_percentage: number;
    };
  };
}

const TargetCard: React.FC<TargetCardProps> = ({
  occupancyInsightsData,
  todayCarbonFootprintData,
}) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  useEffect(() => {
    if (occupancyInsightsData?.data?.length > 4) {
      const interval = setInterval(() => {
        setCurrentIndex(
          (prev) => (prev + 4) % occupancyInsightsData.data.length
        );
      }, 15000);
      return () => clearInterval(interval);
    }
  }, [occupancyInsightsData]);

  return (
    <div className="flex flex-col justify-between h-full w-full">
      <div className="flex flex-col justify-between rounded-[20px] border border-[#EDEFF9] shadow-cardborder bg-white gap-3 pb-4 pt-3 px-5 h-full">
        <div className="flex flex-col gap-5">
          <div className="flex items-center gap-2 w-full">
            <img src={logo} alt="logo" className="h-[60px]" />
            <div className="flex flex-col">
              <P
                fontSize="32px"
                color="#1D1D1C"
                fontWeight="700"
                className="tracking-[0.014px]"
              >
                อาคารศูนย์เรียนรู้สุขภาวะ
              </P>
              <P
                fontSize="20px"
                color="#1D1D1C"
                fontWeight="700"
                className="tracking-[0.009px] -mt-2"
              >
                สำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ
              </P>
            </div>
          </div>
          <img
            src={Thaihealth}
            alt="Thaihealth"
            className="w-full rounded-lg h-[250px] object-cover object-top"
          />
          <div className="border border-[#EDEFF9] bg-[#F8F8F8CC] rounded-lg p-[10px]">
            <div className="flex items-center justify-between">
              <P fontSize="24px" fontWeight="700" color="#1D1D1C">
                อัตราการปล่อยคาร์บอนฟุตพริ้นท์วันนี้
              </P>
            </div>
            <div className="flex items-center justify-between">
              <P fontSize="35px" color="#5A6B7F">
                <span className="text-[#000000]">
                  {(
                    todayCarbonFootprintData?.data.carbon_total || 0
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
                <span className="mt-3"> kgCO₂e</span>
              </P>
            </div>
            <div className=" relative">
              <SingleBar
                firstValue={
                  todayCarbonFootprintData?.data.staff_percentage || 0
                }
                secondValue={
                  todayCarbonFootprintData?.data.visitor_percentage || 0
                }
                firstColor="#E4883E"
                secondColor="#7BBD60"
              />
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-center mt-3">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-[#E4883E] rounded"></div>
                    <span className="text-[20px]">บุคลากรภายใน</span>
                  </div>
                  <span>
                    {(
                      (todayCarbonFootprintData?.data.carbon_total || 0) *
                      (todayCarbonFootprintData?.data.staff_percentage || 0)
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    <span className="text-[#3D4A5C] ml-2"> kgCO₂e</span>
                  </span>
                </div>

                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-[#7BBD60] rounded"></div>
                    <span className="text-[20px]">บุคคลภายนอก</span>
                  </div>
                  <span>
                    {(
                      (todayCarbonFootprintData?.data.carbon_total || 0) *
                      (todayCarbonFootprintData?.data.visitor_percentage || 0)
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    <span className="text-[#3D4A5C] ml-2"> kgCO₂e</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <P
            fontSize="32px"
            color="#1D1D1C"
            fontWeight="700"
            className="tracking-[0.014px] flex-shrink-0"
          >
            Insights
          </P>
          <div className="flex flex-col gap-3 flex-1 min-h-0">
            {Array.from({ length: 4 }).map((_, index) => {
              const dataLength = occupancyInsightsData?.data?.length || 0;
              const itemIndex = (currentIndex + index) % dataLength;
              const item = occupancyInsightsData?.data?.[itemIndex];
              if (!item) return null;
              return (
                <div
                  key={`${currentIndex}-${index}`}
                  className="bg-white p-4 rounded-xl flex items-center h-[88px] overflow-hidden border-2 border-[#edeff9] shadow-lg"
                >
                  <P
                    fontSize="22px"
                    color="#1D1D1C"
                    fontWeight="700"
                    className="tracking-[0.009px] break-words line-clamp-3"
                  >
                    {item.insight_message}
                  </P>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TargetCard;
